const key = "item-deactivated-at";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	if(!resp.data.Data?.Fields)
		return;
	resp.data.Data.Fields.forEach(field => {
		if(!field.Data)
			return;

		let count = 0;
		
		// this is intended to test items with no deactivatedAt property, a distant one, and a past one.
		field.Data.forEach(item => {
			switch((count++) % 3) {
				case 0:
					item.DeactivatedAt = "2021-04-01T05:00:00.000Z";
					break;
				case 1: 
					item.DeactivatedAt = "2100-01-01T06:00:00.000Z";
					break;
				case 2:
					break;
				default: 
					break;
			}
			count++;
		});
	});
};

export const itemDeactivatedAt = [key, applicable, modify];